import {
  ORDER_STATUS_TIMELINE_GHOST,
  ORDER_DETAILS_CARD_GHOST,
  ORDER_DETAILS_IMAGES_GHOST,
  ORDER_DETAILS_SUMMARY_GHOST,
  ORDER_DETAILS_NOTES_GHOST,
  ORDER_DETAILS_HEADER_GHOST,
} from "@/app/constants/ghostHeights";
import { Box, Grid } from "@mui/material";
import Ghost from "../shared/ghost";
import GhostList from "../shared/ghostList";

const OrderDetailsSectionsLayoutGhost = () => {
  return (
    <Box sx={{ backgroundColor: "#f8f8f8", p: 3 }}>
      <Box className="page-title" mb={2}>
        <Ghost height={ORDER_DETAILS_HEADER_GHOST} />
      </Box>
      <Box mb={2}>
        <Ghost height={ORDER_STATUS_TIMELINE_GHOST} />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5.5}>
          <Ghost height={ORDER_DETAILS_CARD_GHOST} />
        </Grid>
        <Grid item xs={12} md={3}>
          <Ghost height={ORDER_DETAILS_SUMMARY_GHOST} />
        </Grid>
        <Grid item xs={12} md={3.5}>
          <GhostList ghostHeight={ORDER_DETAILS_IMAGES_GHOST} count={2} />
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={12}>
          <GhostList ghostHeight={ORDER_DETAILS_NOTES_GHOST} count={2} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderDetailsSectionsLayoutGhost;
